<main>
    <div class="signup_left">
      <h1>Prêt à bouger et t’amuser ?</h1>
      <h3>Viens t'amuser avec <b>Acajoux</b> </h3>
      <a href="https://jeuxdelacadie.org/les-etoiles/">En savoir plus sur les Étoiles</a>
    </div>
    <div class="signup_right">
      <img class="acadie_logo" src="../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="Jeux-de-l-acadie_logo">
      <h1 class="signup_bienvenue">S'inscrire aux <b  style="color: #D4AB16">Étoiles d'Acajoux!</b></h1>
      <div class="signup-form">
        <mat-form-field class="signup_inputs signup_courriel">
            <mat-label>Prénom</mat-label>
            <input type="text" matInput placeholder="Ex. Joe" [(ngModel)]="prenom">
        </mat-form-field>
        <mat-form-field class="signup_inputs signup_courriel">
            <mat-label>Nom</mat-label>
            <input type="text" matInput placeholder="Ex. Doe" [(ngModel)]="nom">
        </mat-form-field>
        <mat-form-field class="signup_inputs signup_courriel">
            <mat-label>Nom d'utilisateur</mat-label>
            <input type="text" matInput placeholder="Ex. JoeDoe" [(ngModel)]="username">
        </mat-form-field>
        <mat-form-field class="signup_inputs signup_courriel">
          <mat-label>Courriel</mat-label>
          <input type="email" matInput placeholder="Ex. johndoe@email.ca" [(ngModel)]="courriel">
        </mat-form-field>
        <label class="signup_province" for="province-select">
            <p>Province</p>
            <select name="province-select" class="signup_province-select" [(ngModel)]="province" (change)="onProvinceChosen()">
                <option value="Île-du-Prince-Édouard">Île-du-Prince-Édouard</option>
                <option value="Nouveau-Brunswick">Nouveau-Brunswick</option>
                <option value="Nouvelle-Écosse">Nouvelle-Écosse</option>
                <option value="Terre-Neuve et Labrador">Terre-Neuve et Labrador</option>
            </select>
        </label>
        <label class="signup_region" for="region-select" *ngIf="province != ''">
            <p>Région</p>
            <select name="region-select" class="signup_region-select" [(ngModel)]="regionId" (change)="onRegionChosen()">
              <option value=""></option>
              <option *ngFor="let region of regions" value="{{region.id}}">{{region.nom}}</option>
            </select>
        </label>
        <label class="signup_ecole" for="ecole-select" *ngIf="regionId != ''">
          <p>École</p>
          <select name="ecole-select" class="signup_ecole-select" [(ngModel)]="schoolId">
            <option value=""></option>
            <option *ngFor="let ecole of ecolesAray" value="{{ecole.ecole_id}}">{{ecole.nom}}</option>
          </select>
        </label>
        <label class="signup_type" for="type-select">
          <p>Quel type d'utilisateur êtes-vous?</p>
          <select name="type-select" class="signup_type-select" [(ngModel)]="type">
              <option  value="participant">Participant</option>
              <option  value="enseignant">Enseignant</option>
          </select>
        </label>
        <mat-form-field class="signup_inputs signup_mdp">
          <mat-label>Mot de passe</mat-label>
          <input type="password" matInput [(ngModel)]="password">
        </mat-form-field>
        <mat-form-field class="signup_inputs signup_mdp">
          <mat-label>Confirmez le mot de passe</mat-label>
          <input type="password" matInput [(ngModel)]="confirmPassword">
        </mat-form-field>
      </div>
      <button class="btn_s_inscsrire" (click)="signUp()">S'Inscrire</button>
    </div>
  </main>